import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, ShoppingBagIcon, StarIcon, TruckIcon, ShieldCheckIcon, HeartIcon, MinusIcon, PlusIcon, CheckIcon, InfoIcon, Droplet } from 'lucide-react';
import { useCart, Product } from '../context/CartContext';
import ProductCard from '../components/ProductCard';
// Product data - would normally come from an API
const allProducts: Product[] = [{
  id: 1,
  name: 'Lavender Essential Oil',
  price: 'KSh 700',
  priceValue: 700,
  rating: 5,
  reviews: 124,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g394rGy1FjPfeRVqVb6B84/screencapture-shiriakaoils-wp-admin-post-php-2025-07-26-15_41_18.png',
  description: "A staple part of the plant with heavenly oils that are proven to be beneficial to humans in high doses. Lavender has a wide range of benefits you can put to use each and every day. The aroma itself can help promote a calm, peaceful, yet tranquil atmosphere. It is wonderful to diffuse before bedtime to help provide a good night's rest or to simply enjoy a sense of relaxation. It helps to calm feelings of stress and emotional exhaustion, offering a sweet, natural way to experience calm whenever you need it.",
  badge: 'Best Seller',
  category: 'single',
  size: '15ml',
  origin: 'India',
  usage: 'Diffusion, topical application when diluted, aromatic use',
  benefits: ['Promotes relaxation', 'Supports healthy sleep', 'Soothes occasional skin irritations', 'Supports mental health'],
  ingredients: '100% pure Lavandula angustifolia (Lavender) oil',
  botanicalName: 'Lavandula angustifolia',
  aromaticScent: 'Sweet, dry, and herbaceous-floral',
  shelfLife: '3-4 Years',
  howToUse: ['Diffuse into the air, add a few drops in a carrier oil for a warm bath, put a drop or two on a cotton pad next to your pillow, or add to unscented lotion or carrier oil to enjoy a sense of relaxation.', 'Aromatic: Diffuse using 3-4 drops per 100 mL of water or use in a personal inhaler.', 'Topical: Dilute to 2-5% in a carrier.'],
  safetyInfo: ['KidSafe', 'Pregnancy Safe', 'Nursing Safe', 'Pup & Pony Safe'],
  cautions: "Keep out of reach of children. If pregnant or under a doctor's care, consult your physician. External use only.",
  overview: ['Fantastic for relaxation', 'Supports mental health', 'Familiar floral scent'],
  additionalInfo: 'Once added to a carrier oil, Lavender can help soothe the skin, making it a valuable addition to your natural healing kit for minor cuts and scrapes, thanks to its cleansing properties. Lavender can also support healthy skin by soothing red, irritated areas.'
}, {
  id: 2,
  name: 'Ylang Ylang Essential Oil',
  price: 'KSh 900',
  priceValue: 900,
  rating: 4.9,
  reviews: 87,
  image: 'https://shiriakaoils.com/wp-content/uploads/2025/07/Ylang-Ylang-blob-v1-IMAGE-7Y25n9OQMz8.png',
  description: 'Indulge in the intoxicating, floral aroma of Ylang Ylang Complete. This intensely sweet and heady oil is a favorite for use in romantic blends for its aphrodisiac properties. In addition to helping set a sensual mood, this excellent oil is calming, soothing, and uplifting, which makes it great for all skin types. It helps encourage full-body relaxation, making it a wonderful choice for a DIY romantic massage oil. For something truly exotic and romantic, pair with other sultry oils like Sandalwood and Black Pepper. You can also use Ylang Ylang to help prevent signs of aging and promote healthy skin. Its sebum-balancing effects make it great for all skin types.',
  badge: 'Popular',
  category: 'single',
  size: '15ml',
  origin: 'Kenya',
  usage: 'Diffusion, topical application when diluted, aromatic use',
  benefits: ['Encourages healthy, radiant-looking skin & hair', 'Promotes a loving, romantic atmosphere', 'Emotionally uplifting & encouraging', 'Helps prevent signs of aging'],
  ingredients: '100% pure Cananga odorata (Ylang Ylang) oil',
  botanicalName: 'Cananga odorata',
  aromaticScent: 'Intensely sweet, heady exotic floral scent',
  shelfLife: '2-3 Years',
  howToUse: ['Aromatic: Diffuse using 2-3 drops per 100 mL of water or use in a personal inhaler.', 'Topical: Dilute to a maximum of 0.8% in a carrier.', 'Add to unscented lotion or carrier oil for a romantic massage blend.', 'Use in a personal inhaler for an emotionally uplifting experience throughout the day.'],
  safetyInfo: ['KidSafe', 'Pregnancy Safe', 'Pup & Pony Safe'],
  cautions: "Maximum dilution of 0.8% for topical applications. Keep out of reach of children. If pregnant or under a doctor's care, consult your physician. External use only.",
  overview: ['Encourages healthy, radiant-looking skin & hair', 'Promotes a loving, romantic atmosphere', 'Emotionally uplifting & encouraging'],
  additionalInfo: 'Ylang Ylang has a balancing effect on sebum production, making it beneficial for both dry and oily skin types. Its exotic floral scent is known for its mood-enhancing properties and is often used in high-end perfumes and aromatherapy blends.'
}, {
  id: 3,
  name: 'Eucalyptus Essential Oil',
  price: 'KSh 1,300',
  priceValue: 1300,
  rating: 4.8,
  reviews: 76,
  image: 'https://images.unsplash.com/photo-1600857544200-b2f468e9d10d?q=80&w=600&auto=format&fit=crop',
  description: 'Refreshing oil that promotes clear breathing. Our Eucalyptus oil, steam-distilled from the leaves of Eucalyptus globulus, has a fresh and invigorating aroma, which creates a refreshing atmosphere.',
  badge: 'New',
  category: 'single',
  size: '15ml',
  origin: 'Kenya',
  usage: 'Diffusion, steam inhalation, topical application when diluted',
  benefits: ['Promotes clear breathing', 'Creates an invigorating atmosphere', 'Refreshing aroma'],
  ingredients: '100% pure Eucalyptus globulus (Eucalyptus) oil'
}, {
  id: 4,
  name: 'Lemongrass Essential Oil',
  price: 'KSh 1,100',
  priceValue: 1100,
  rating: 4.7,
  reviews: 65,
  image: 'https://images.unsplash.com/photo-1601055283742-8b27e81b5553?q=80&w=600&auto=format&fit=crop',
  description: 'Citrusy oil that helps reduce stress. Our Lemongrass oil is steam-distilled from the leaves of Cymbopogon flexuosus. Its fresh, lemony aroma is uplifting and purifying.',
  category: 'single',
  size: '15ml',
  origin: 'Kenya',
  usage: 'Diffusion, topical application when diluted, natural insect repellent',
  benefits: ['Uplifting aroma', 'Purifying properties', 'Natural insect repellent'],
  ingredients: '100% pure Cymbopogon flexuosus (Lemongrass) oil'
}, {
  id: 5,
  name: 'Sandalwood Essential Oil',
  price: 'KSh 2,200',
  priceValue: 2200,
  rating: 4.9,
  reviews: 92,
  image: 'https://images.unsplash.com/photo-1595981267006-5a2140753a5c?q=80&w=600&auto=format&fit=crop',
  description: 'Luxurious and grounding oil with a rich, woody aroma. Perfect for meditation, relaxation, and skin care.',
  category: 'single',
  size: '10ml',
  origin: 'India',
  usage: 'Diffusion, topical application when diluted, meditation',
  benefits: ['Promotes mental clarity', 'Grounding and calming', 'Supports healthy skin', 'Enhances meditation practices'],
  ingredients: '100% pure Santalum album (Sandalwood) oil'
}, {
  id: 6,
  name: 'Black Pepper Essential Oil',
  price: 'KSh 1,400',
  priceValue: 1400,
  rating: 4.6,
  reviews: 58,
  image: 'https://images.unsplash.com/photo-1599909380654-a0801953bfcd?q=80&w=600&auto=format&fit=crop',
  description: 'Spicy, warm oil that adds depth to blends and provides warming comfort to muscles.',
  category: 'single',
  size: '15ml',
  origin: 'Madagascar',
  usage: 'Diffusion, topical application when diluted, massage',
  benefits: ['Provides warming sensation', 'Supports healthy circulation', 'Adds depth to essential oil blends'],
  ingredients: '100% pure Piper nigrum (Black Pepper) oil'
}, {
  id: 7,
  name: 'Romantic Blend Essential Oil',
  price: 'KSh 1,800',
  priceValue: 1800,
  rating: 4.9,
  reviews: 64,
  image: 'https://images.unsplash.com/photo-1608571423899-ec3cdb9a3a65?q=80&w=600&auto=format&fit=crop',
  description: 'A sensual blend of Ylang Ylang, Sandalwood, and other exotic oils designed to create a romantic atmosphere.',
  badge: 'Best Seller',
  category: 'blend',
  size: '10ml',
  origin: 'Kenya',
  usage: 'Diffusion, personal perfume when diluted',
  benefits: ['Creates a romantic atmosphere', 'Emotionally uplifting', 'Exotic and sensual aroma'],
  ingredients: 'Blend of Ylang Ylang, Sandalwood, Rose, and Jasmine oils'
}];
const SingleProductPage = () => {
  const {
    productId
  } = useParams<{
    productId: string;
  }>();
  const {
    addToCart
  } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('details');
  // Find the product based on the ID from the URL
  const product = allProducts.find(p => p.id === parseInt(productId || '0'));
  // Get related products based on complementary oils mentioned in the description
  // or products in the same category
  const getRelatedProducts = (currentProduct: Product) => {
    if (!currentProduct) return [];
    // For Ylang Ylang, specifically show Sandalwood and Black Pepper as mentioned in description
    if (currentProduct.id === 2) {
      return allProducts.filter(p => p.id === 5 || p.id === 6 || p.id === 7 || p.category === currentProduct.category && p.id !== currentProduct.id).slice(0, 4);
    }
    // Default related products logic
    return allProducts.filter(p => p.category === currentProduct.category && p.id !== currentProduct.id).slice(0, 4);
  };
  const relatedProducts = product ? getRelatedProducts(product) : [];
  // Handle quantity change
  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };
  // Handle add to cart
  const handleAddToCart = () => {
    if (product) {
      for (let i = 0; i < quantity; i++) {
        addToCart(product);
      }
    }
  };
  // If product not found
  if (!product) {
    return <div className="min-h-screen bg-[#f8f9f4] py-12 px-4" data-id="element-1070">
        <div className="max-w-7xl mx-auto text-center" data-id="element-1071">
          <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1072">
            Product Not Found
          </h1>
          <p className="text-gray-600 mb-8" data-id="element-1073">
            The product you're looking for doesn't exist or has been removed.
          </p>
          <Link to="/products" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#2e7d32] hover:bg-[#1b5e20]" data-id="element-1074">
            <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-1075" />
            Back to Products
          </Link>
        </div>
      </div>;
  }
  return <div className="bg-[#f8f9f4] w-full" data-id="element-1076">
      {/* Breadcrumb */}
      <div className="bg-white border-b" data-id="element-1077">
        <div className="container mx-auto px-4 py-3" data-id="element-1078">
          <nav className="flex text-sm" data-id="element-1079">
            <Link to="/" className="text-gray-500 hover:text-[#2e7d32]" data-id="element-1080">
              Home
            </Link>
            <span className="mx-2 text-gray-400" data-id="element-1081">/</span>
            <Link to="/products" className="text-gray-500 hover:text-[#2e7d32]" data-id="element-1082">
              Products
            </Link>
            <span className="mx-2 text-gray-400" data-id="element-1083">/</span>
            <Link to={`/category/${product.category}`} className="text-gray-500 hover:text-[#2e7d32] capitalize" data-id="element-1084">
              {product.category}
            </Link>
            <span className="mx-2 text-gray-400" data-id="element-1085">/</span>
            <span className="text-gray-700 font-medium" data-id="element-1086">{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Product Details */}
      <div className="container mx-auto px-4 py-12" data-id="element-1087">
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-1088">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1089">
            {/* Product Image */}
            <div className="p-6 md:p-8" data-id="element-1090">
              <div className="aspect-square rounded-lg overflow-hidden bg-[#f8f9f4]" data-id="element-1091">
                <img src={product.image} alt={product.name} className="w-full h-full object-contain" onError={e => {
                e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
              }} data-id="element-1092" />
              </div>
            </div>

            {/* Product Info */}
            <div className="p-6 md:p-8 flex flex-col" data-id="element-1093">
              {/* Badge */}
              {product.badge && <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#f0f7eb] text-[#2e7d32] mb-4 self-start" data-id="element-1094">
                  {product.badge}
                </span>}

              {/* Title & Rating */}
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-1095">
                {product.name}
              </h1>
              <div className="flex items-center mb-4" data-id="element-1096">
                <div className="flex" data-id="element-1097">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : i < product.rating ? 'text-yellow-400 fill-yellow-400 opacity-50' : 'text-gray-300'}`} data-id="element-1098" />)}
                </div>
                <span className="text-sm text-gray-500 ml-2" data-id="element-1099">
                  ({product.reviews} reviews)
                </span>
              </div>

              {/* Short Description */}
              <div className="mb-4 text-sm text-gray-600" data-id="element-1100">
                <p data-id="element-1101">
                  <span className="font-medium" data-id="element-1102">Botanical Name:</span>{' '}
                  {product.botanicalName}
                </p>
                <p data-id="element-1103">
                  <span className="font-medium" data-id="element-1104">Aromatic Scent:</span>{' '}
                  {product.aromaticScent}
                </p>
                <p data-id="element-1105">
                  <span className="font-medium" data-id="element-1106">Shelf Life:</span>{' '}
                  {product.shelfLife}
                </p>
                <p data-id="element-1107">
                  <span className="font-medium" data-id="element-1108">Country of Origin:</span>{' '}
                  {product.origin}
                </p>
              </div>

              {/* Price */}
              <div className="text-2xl font-bold text-[#2e7d32] mb-4" data-id="element-1109">
                {product.price}
              </div>

              {/* Safety Information */}
              <div className="mb-4" data-id="element-1110">
                <div className="flex flex-wrap gap-2" data-id="element-1111">
                  {product.safetyInfo?.map((info, index) => <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1112">
                      <CheckIcon className="mr-1 h-3 w-3" data-id="element-1113" />
                      {info}
                    </span>)}
                </div>
              </div>

              {/* Quantity */}
              <div className="mb-6" data-id="element-1114">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1115">
                  Quantity
                </label>
                <div className="flex items-center" data-id="element-1116">
                  <button onClick={decreaseQuantity} className="p-2 border border-gray-300 rounded-l-md bg-gray-50 hover:bg-gray-100" data-id="element-1117">
                    <MinusIcon className="h-4 w-4 text-gray-600" data-id="element-1118" />
                  </button>
                  <input type="text" value={quantity} readOnly className="w-16 text-center border-t border-b border-gray-300 py-2" data-id="element-1119" />
                  <button onClick={increaseQuantity} className="p-2 border border-gray-300 rounded-r-md bg-gray-50 hover:bg-gray-100" data-id="element-1120">
                    <PlusIcon className="h-4 w-4 text-gray-600" data-id="element-1121" />
                  </button>
                </div>
              </div>

              {/* Add to Cart & Wishlist */}
              <div className="flex flex-col sm:flex-row gap-4 mt-auto" data-id="element-1122">
                <button onClick={handleAddToCart} className="flex-1 bg-[#2e7d32] hover:bg-[#1b5e20] text-white py-3 px-6 rounded-lg flex items-center justify-center gap-2 transition-colors" data-id="element-1123">
                  <ShoppingBagIcon className="h-5 w-5" data-id="element-1124" />
                  Add to Cart
                </button>
                <button className="flex items-center justify-center gap-2 py-3 px-6 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1125">
                  <HeartIcon className="h-5 w-5 text-gray-600" data-id="element-1126" />
                  <span className="text-gray-700" data-id="element-1127">Save</span>
                </button>
              </div>

              {/* Shipping & Returns */}
              <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-1128">
                <div className="flex items-center gap-3 mb-3" data-id="element-1129">
                  <TruckIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-1130" />
                  <span className="text-sm text-gray-600" data-id="element-1131">
                    Free shipping on orders over KSh 5,000
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-1132">
                  <ShieldCheckIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-1133" />
                  <span className="text-sm text-gray-600" data-id="element-1134">
                    30-day money-back guarantee
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Details Tabs */}
        <div className="mt-12 bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-1135">
          <div className="border-b border-gray-200" data-id="element-1136">
            <nav className="-mb-px flex space-x-8 overflow-x-auto px-6" data-id="element-1137">
              <button onClick={() => setActiveTab('details')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'details' ? 'border-[#2e7d32] text-[#2e7d32]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1138">
                Details
              </button>
              <button onClick={() => setActiveTab('usage')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'usage' ? 'border-[#2e7d32] text-[#2e7d32]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1139">
                How to Use
              </button>
              <button onClick={() => setActiveTab('benefits')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'benefits' ? 'border-[#2e7d32] text-[#2e7d32]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1140">
                Benefits
              </button>
              <button onClick={() => setActiveTab('reviews')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews' ? 'border-[#2e7d32] text-[#2e7d32]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1141">
                Reviews
              </button>
            </nav>
          </div>
          <div className="p-6 md:p-8" data-id="element-1142">
            {activeTab === 'details' && <div data-id="element-1143">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1144">
                  Product Description
                </h3>
                <div className="prose max-w-none text-gray-600 space-y-4" data-id="element-1145">
                  <p data-id="element-1146">{product.description}</p>
                  <p data-id="element-1147">{product.additionalInfo}</p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-1148">
                    <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1149">
                      <h4 className="font-medium text-gray-900 mb-2" data-id="element-1150">
                        Product Details
                      </h4>
                      <ul className="space-y-2" data-id="element-1151">
                        <li className="flex" data-id="element-1152">
                          <span className="w-32 text-gray-500" data-id="element-1153">
                            Botanical Name:
                          </span>
                          <span className="text-gray-900" data-id="element-1154">
                            {product.botanicalName}
                          </span>
                        </li>
                        <li className="flex" data-id="element-1155">
                          <span className="w-32 text-gray-500" data-id="element-1156">
                            Aromatic Scent:
                          </span>
                          <span className="text-gray-900" data-id="element-1157">
                            {product.aromaticScent}
                          </span>
                        </li>
                        <li className="flex" data-id="element-1158">
                          <span className="w-32 text-gray-500" data-id="element-1159">
                            Shelf Life:
                          </span>
                          <span className="text-gray-900" data-id="element-1160">
                            {product.shelfLife}
                          </span>
                        </li>
                        <li className="flex" data-id="element-1161">
                          <span className="w-32 text-gray-500" data-id="element-1162">
                            Country of Origin:
                          </span>
                          <span className="text-gray-900" data-id="element-1163">
                            {product.origin}
                          </span>
                        </li>
                        <li className="flex" data-id="element-1164">
                          <span className="w-32 text-gray-500" data-id="element-1165">Size:</span>
                          <span className="text-gray-900" data-id="element-1166">{product.size}</span>
                        </li>
                      </ul>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1167">
                      <h4 className="font-medium text-gray-900 mb-2" data-id="element-1168">
                        Ingredients
                      </h4>
                      <p className="text-gray-700" data-id="element-1169">{product.ingredients}</p>
                      <h4 className="font-medium text-gray-900 mt-4 mb-2" data-id="element-1170">
                        Safety Information
                      </h4>
                      <ul className="space-y-1" data-id="element-1171">
                        {product.safetyInfo?.map((info, index) => <li key={index} className="flex items-center" data-id="element-1172">
                            <CheckIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-1173" />
                            <span data-id="element-1174">{info}</span>
                          </li>)}
                      </ul>
                      <div className="mt-4 p-3 bg-amber-50 rounded-lg border border-amber-100" data-id="element-1175">
                        <div className="flex" data-id="element-1176">
                          <InfoIcon className="h-5 w-5 text-amber-500 mr-2 flex-shrink-0" data-id="element-1177" />
                          <p className="text-sm text-amber-800" data-id="element-1178">
                            {product.cautions}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {activeTab === 'usage' && <div data-id="element-1179">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1180">
                  How to Use
                </h3>
                <div className="prose max-w-none text-gray-600" data-id="element-1181">
                  {product.howToUse?.map((instruction, index) => <p key={index} className="mb-4" data-id="element-1182">
                      {instruction}
                    </p>)}
                  <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1183">
                    <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1184">
                      <div className="flex items-center mb-2" data-id="element-1185">
                        <Droplet className="h-5 w-5 text-blue-500 mr-2" data-id="element-1186" />
                        <h4 className="font-medium text-gray-900" data-id="element-1187">Aromatic</h4>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-1188">
                        Diffuse using 2-3 drops per 100 mL of water or use in a
                        personal inhaler.
                      </p>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg" data-id="element-1189">
                      <div className="flex items-center mb-2" data-id="element-1190">
                        <Droplet className="h-5 w-5 text-green-500 mr-2" data-id="element-1191" />
                        <h4 className="font-medium text-gray-900" data-id="element-1192">Topical</h4>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-1193">
                        Dilute to a maximum of 0.8% in a carrier oil before
                        applying to skin.
                      </p>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg" data-id="element-1194">
                      <div className="flex items-center mb-2" data-id="element-1195">
                        <Droplet className="h-5 w-5 text-purple-500 mr-2" data-id="element-1196" />
                        <h4 className="font-medium text-gray-900" data-id="element-1197">Massage</h4>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-1198">
                        Blend with Sandalwood or Black Pepper for a romantic
                        massage oil.
                      </p>
                    </div>
                  </div>
                  <div className="mt-6 p-4 border border-gray-200 rounded-lg" data-id="element-1199">
                    <h4 className="font-medium text-gray-900 mb-2" data-id="element-1200">
                      Safety Information
                    </h4>
                    <div className="flex flex-wrap gap-2" data-id="element-1201">
                      {product.safetyInfo?.map((info, index) => <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1202">
                          <CheckIcon className="mr-1 h-3 w-3" data-id="element-1203" />
                          {info}
                        </span>)}
                    </div>
                    <p className="mt-3 text-sm text-gray-600" data-id="element-1204">
                      {product.cautions}
                    </p>
                  </div>
                </div>
              </div>}
            {activeTab === 'benefits' && <div data-id="element-1205">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1206">
                  Benefits & Overview
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1207">
                  <div data-id="element-1208">
                    <h4 className="font-medium text-gray-900 mb-3" data-id="element-1209">
                      Key Benefits
                    </h4>
                    <ul className="space-y-3" data-id="element-1210">
                      {product.benefits?.map((benefit, index) => <li key={index} className="flex" data-id="element-1211">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1212" />
                          <span className="text-gray-700" data-id="element-1213">{benefit}</span>
                        </li>)}
                    </ul>
                    <h4 className="font-medium text-gray-900 mt-6 mb-3" data-id="element-1214">
                      Overview
                    </h4>
                    <ul className="space-y-3" data-id="element-1215">
                      {product.overview?.map((point, index) => <li key={index} className="flex" data-id="element-1216">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" data-id="element-1217" />
                          <span className="text-gray-700" data-id="element-1218">{point}</span>
                        </li>)}
                    </ul>
                  </div>
                  <div className="bg-[#f0f7eb] p-6 rounded-lg" data-id="element-1219">
                    <h4 className="font-medium text-gray-900 mb-4" data-id="element-1220">
                      {product.id === 2 ? 'Why Choose Our Ylang Ylang Oil' : `Why Choose Our ${product.name}`}
                    </h4>
                    <p className="text-gray-700 mb-4" data-id="element-1221">
                      {product.id === 2 ? 'Our Ylang Ylang essential oil is steam-distilled from the flowers of Cananga odorata, harvested at the perfect time to ensure the highest quality oil with optimal therapeutic properties.' : `Our ${product.name.split(' ')[0]} essential oil is carefully extracted to preserve its natural therapeutic properties and ensure the highest quality.`}
                    </p>
                    <div className="space-y-3 mt-4" data-id="element-1222">
                      <div className="flex" data-id="element-1223">
                        <CheckIcon className="h-5 w-5 text-[#2e7d32] mr-3 flex-shrink-0" data-id="element-1224" />
                        <span className="text-gray-700" data-id="element-1225">
                          100% pure with no additives or fillers
                        </span>
                      </div>
                      <div className="flex" data-id="element-1226">
                        <CheckIcon className="h-5 w-5 text-[#2e7d32] mr-3 flex-shrink-0" data-id="element-1227" />
                        <span className="text-gray-700" data-id="element-1228">
                          Ethically sourced from sustainable farms
                        </span>
                      </div>
                      <div className="flex" data-id="element-1229">
                        <CheckIcon className="h-5 w-5 text-[#2e7d32] mr-3 flex-shrink-0" data-id="element-1230" />
                        <span className="text-gray-700" data-id="element-1231">
                          Rigorously tested for purity and potency
                        </span>
                      </div>
                      <div className="flex" data-id="element-1232">
                        <CheckIcon className="h-5 w-5 text-[#2e7d32] mr-3 flex-shrink-0" data-id="element-1233" />
                        <span className="text-gray-700" data-id="element-1234">
                          Versatile for aromatherapy, topical use, and more
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {activeTab === 'reviews' && <div data-id="element-1235">
                <div className="flex items-center justify-between mb-6" data-id="element-1236">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-1237">
                    Customer Reviews
                  </h3>
                  <button className="px-4 py-2 bg-[#2e7d32] text-white rounded-lg hover:bg-[#1b5e20] transition-colors text-sm" data-id="element-1238">
                    Write a Review
                  </button>
                </div>
                <div className="flex items-center mb-6" data-id="element-1239">
                  <div className="flex mr-4" data-id="element-1240">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" data-id="element-1241" />)}
                  </div>
                  <span className="text-gray-700" data-id="element-1242">
                    Based on {product.reviews} reviews
                  </span>
                </div>
                <div className="space-y-6" data-id="element-1243">
                  {product.id === 2 ? <>
                      <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1244">
                        <div className="flex items-center justify-between mb-2" data-id="element-1245">
                          <div className="flex items-center" data-id="element-1246">
                            <div className="h-10 w-10 rounded-full bg-[#e8f5e9] flex items-center justify-center mr-3" data-id="element-1247">
                              <span className="text-[#2e7d32] font-medium" data-id="element-1248">
                                LN
                              </span>
                            </div>
                            <div data-id="element-1249">
                              <h4 className="font-medium text-gray-900" data-id="element-1250">
                                Lisa Njeri
                              </h4>
                              <p className="text-xs text-gray-500" data-id="element-1251">
                                Verified Buyer
                              </p>
                            </div>
                          </div>
                          <div className="flex" data-id="element-1252">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-1253" />)}
                          </div>
                        </div>
                        <p className="text-gray-700" data-id="element-1254">
                          This Ylang Ylang oil is absolutely divine! The floral
                          scent is intoxicating and exotic. I've been adding a
                          drop to my unscented lotion for a natural perfume, and
                          my husband loves it. Also great for creating a
                          romantic atmosphere when diffused.
                        </p>
                        <p className="text-sm text-gray-500 mt-2" data-id="element-1255">
                          Posted on August 12, 2023
                        </p>
                      </div>
                      <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1256">
                        <div className="flex items-center justify-between mb-2" data-id="element-1257">
                          <div className="flex items-center" data-id="element-1258">
                            <div className="h-10 w-10 rounded-full bg-[#e8f5e9] flex items-center justify-center mr-3" data-id="element-1259">
                              <span className="text-[#2e7d32] font-medium" data-id="element-1260">
                                DK
                              </span>
                            </div>
                            <div data-id="element-1261">
                              <h4 className="font-medium text-gray-900" data-id="element-1262">
                                David Kamau
                              </h4>
                              <p className="text-xs text-gray-500" data-id="element-1263">
                                Verified Buyer
                              </p>
                            </div>
                          </div>
                          <div className="flex" data-id="element-1264">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className={i < 4 ? 'h-4 w-4 text-yellow-400 fill-yellow-400' : 'h-4 w-4 text-gray-300'} data-id="element-1265" />)}
                          </div>
                        </div>
                        <p className="text-gray-700" data-id="element-1266">
                          I purchased this to help with stress and relaxation.
                          The scent is quite strong, so a little goes a long
                          way! I've been mixing it with Sandalwood as suggested
                          and it creates a wonderful calming blend for my
                          diffuser. My only suggestion would be to include more
                          detailed blending recommendations.
                        </p>
                        <p className="text-sm text-gray-500 mt-2" data-id="element-1267">
                          Posted on July 29, 2023
                        </p>
                      </div>
                    </> : <>
                      <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1268">
                        <div className="flex items-center justify-between mb-2" data-id="element-1269">
                          <div className="flex items-center" data-id="element-1270">
                            <div className="h-10 w-10 rounded-full bg-[#e8f5e9] flex items-center justify-center mr-3" data-id="element-1271">
                              <span className="text-[#2e7d32] font-medium" data-id="element-1272">
                                SJ
                              </span>
                            </div>
                            <div data-id="element-1273">
                              <h4 className="font-medium text-gray-900" data-id="element-1274">
                                Sarah Johnson
                              </h4>
                              <p className="text-xs text-gray-500" data-id="element-1275">
                                Verified Buyer
                              </p>
                            </div>
                          </div>
                          <div className="flex" data-id="element-1276">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-1277" />)}
                          </div>
                        </div>
                        <p className="text-gray-700" data-id="element-1278">
                          This lavender oil is amazing! The scent is authentic
                          and calming. I use it in my diffuser before bedtime
                          and it helps me relax and fall asleep faster. Highly
                          recommended!
                        </p>
                        <p className="text-sm text-gray-500 mt-2" data-id="element-1279">
                          Posted on July 15, 2023
                        </p>
                      </div>
                      <div className="p-4 border border-gray-200 rounded-lg" data-id="element-1280">
                        <div className="flex items-center justify-between mb-2" data-id="element-1281">
                          <div className="flex items-center" data-id="element-1282">
                            <div className="h-10 w-10 rounded-full bg-[#e8f5e9] flex items-center justify-center mr-3" data-id="element-1283">
                              <span className="text-[#2e7d32] font-medium" data-id="element-1284">
                                MO
                              </span>
                            </div>
                            <div data-id="element-1285">
                              <h4 className="font-medium text-gray-900" data-id="element-1286">
                                Michael Omondi
                              </h4>
                              <p className="text-xs text-gray-500" data-id="element-1287">
                                Verified Buyer
                              </p>
                            </div>
                          </div>
                          <div className="flex" data-id="element-1288">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-1289" />)}
                          </div>
                        </div>
                        <p className="text-gray-700" data-id="element-1290">
                          I've tried many lavender oils and this one is by far
                          the best quality. The scent is pure and not
                          overwhelming. I've been using it diluted on my pillow
                          and for minor skin irritations with great results.
                        </p>
                        <p className="text-sm text-gray-500 mt-2" data-id="element-1291">
                          Posted on June 28, 2023
                        </p>
                      </div>
                    </>}
                  <div className="text-center" data-id="element-1292">
                    <button className="text-[#2e7d32] font-medium hover:underline" data-id="element-1293">
                      Load More Reviews
                    </button>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Related Products */}
        {relatedProducts.length > 0 && <div className="mt-16" data-id="element-1294">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1295">
              {product.id === 2 ? 'Perfect Pairings with Ylang Ylang' : 'You May Also Like'}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1296">
              {relatedProducts.map(relatedProduct => <ProductCard key={relatedProduct.id} product={relatedProduct} data-id="element-1297" />)}
            </div>
          </div>}
      </div>
    </div>;
};
export default SingleProductPage;